import { CategoryQuotationInfo, CategoryQuotationFormItem, CategoryQuotationFileItem, CategoryQuotationCompany, ApiCategoryQuotationRequest, ApiResultAssistantAI } from "Types"

/**
 * @param {CategoryQuotationFormItem} model
 * @returns {ApiCategoryQuotationForm}
 */
const formatAnswer = model => {
  const formatAnswer = item => Array.isArray(item) ? item.join(', ') : item

  const formItemId = model.id
  const answer = formatAnswer(model.value)

  return { formItemId, answer }
}


/**
 * @param {CategoryQuotationFileItem} model
 * @returns {string}
 */
const formatFile = model => {
  return model.path
}


/**
 * @param {CategoryQuotationFormItem} model
 * @returns {number}
 */
const formatCompany = model => {
  return model.id
}

/** * Send a new quotation request for the logged user */
export const formatQuotation = (info: CategoryQuotationInfo, answerList: CategoryQuotationFormItem[], fileList: CategoryQuotationFileItem[] = [], companyList: CategoryQuotationCompany[] = []): ApiCategoryQuotationRequest => {
  const answers = answerList.map(formatAnswer)
  const files = fileList.map(formatFile)
  const companyIds = companyList.map(formatCompany)

  return {
    allowAddCompanies: info.replacement,
    origin: info.origin,
    type: info.type,
    description: info.details,
    periodStartOfService: info.deadline,
    serviceTypeId: info.serviceType,
    addressId: info.address,
    formId: info.form,
    ddd: info.phoneDDD,
    phoneNumber: info.phoneNumber.replace('-', ''),
    answers: answers,
    companyIds: companyIds,
    files: files,
    receiveSponsorship: info.receiveSponsorship,
    crossQuotServiceTypeIds: info.crossQuotServiceTypeIds,
    contactPreference: info.contactPreference
  }
}

export const formatDescriptionAI = (description: string, answerList: CategoryQuotationFormItem[], serviceTypeId: number): ApiResultAssistantAI => {
  const answers = answerList.map(formatAnswer)
  
  return {
    description: description,
    answers: answers,
    serviceTypeId: serviceTypeId
  }

}

export default {
  formatQuotation
}